import { render, staticRenderFns } from "./id-or-passport.vue?vue&type=template&id=1783546c&scoped=true&"
import script from "./id-or-passport.vue?vue&type=script&lang=js&"
export * from "./id-or-passport.vue?vue&type=script&lang=js&"
import style0 from "./id-or-passport.vue?vue&type=style&index=0&id=1783546c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1783546c",
  null
  
)

export default component.exports